import { render, staticRenderFns } from "./TeamCreateUpdate.vue?vue&type=template&id=5e3e0019&scoped=true&"
import script from "./TeamCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./TeamCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3e0019",
  null
  
)

export default component.exports